import {
  MessagingCampaignsListQuery,
  MessagingCampaignsListItemFragment,
  MessagingCampaignDetailsQuery,
  MessagingCampaignDetailsFragment,
} from '@occc/graphql';

export const mapEdgesToMessagingCampaignsArray = (
  edges: MessagingCampaignsListQuery['messagingCampaignsList']['edges'],
): MessagingCampaignsListItemFragment[] => {
  return edges.map((item) => item.node);
};

export const mapEdgesToMessagingCampaignDetails = (
  edges: MessagingCampaignDetailsQuery['campaign']['edges'],
): MessagingCampaignDetailsFragment | null => {
  return edges.map((item) => item.node)?.[0] || null;
};
